import React, { useEffect, useState } from 'react';
import UsersList from '../../components/Admin/Users/Users';
import Loader from '../../components/Loader/Loader';
import { withFirebase } from '../../components/Firebase';
import { collection, onSnapshot } from 'firebase/firestore';

const Users = ({ firebase }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fix: Use firebase.db.collection('users') instead of firebase.users()
    const unsubscribe = onSnapshot(collection(firebase.db, 'users'), (querySnapshot) => {
      const usersObject = querySnapshot.docs;
      setLoading(false);
      setUsers([
        ...usersObject.map((doc) => {
          return {
            ...doc.data(),
            uid: doc.id,
          };
        }),
      ]);
    });
    
    return () => unsubscribe();
  }, [firebase]);

  return (
    <>
      <div className="pt-3">
        {loading ? <Loader /> : <UsersList users={users} firebase={firebase} />}
      </div>
    </>
  );
};

export default withFirebase(Users);